module.exports = __webpack_public_path__ + "img/image-02.5ada9da3.jpg";